<template>
  <div>
    İşlem yapmak için partner.trendyol.com'u kullanınız.
    -
    İşleminiz için daha önce aksiyon almıştınız. 2 dakika süren kontrollerden sonra ürününüzün kilidi kalkacaktır.
  </div>
</template>

<script>
export default {
  name: 'LockReason',
};
</script>
